// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoContainer[data-v-1d448368]{padding:13px 0}.infoContainer p[data-v-1d448368]{margin:0}.infoContainer .top p[data-v-1d448368]{text-align:center}.infoContainer .top .van-button[data-v-1d448368]{width:86px}.infoContainer .right h4[data-v-1d448368]{margin:0 0 10px}.infoContainer .right p[data-v-1d448368]{font-size:14px}[data-v-1d448368]:export{green:#3f9775;white:#fff}", ""]);
// Exports
module.exports = exports;
